import api from './api'

export interface LoginCredentials {
  email: string
  password: string
}

export interface RegisterData {
  email: string
  password: string
  first_name: string
  last_name: string
}

export interface AuthResponse {
  access: string
  refresh: string
  user: {
    id: number
    email: string
    first_name: string
    last_name: string
    role: string
  }
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login/', credentials)
    
    // Salvar tokens no localStorage
    localStorage.setItem('access_token', response.data.access)
    localStorage.setItem('refresh_token', response.data.refresh)
    localStorage.setItem('user', JSON.stringify(response.data.user))
    
    return response.data
  },

  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/register/', data)
    
    // Salvar tokens no localStorage
    localStorage.setItem('access_token', response.data.access)
    localStorage.setItem('refresh_token', response.data.refresh)
    localStorage.setItem('user', JSON.stringify(response.data.user))
    
    return response.data
  },

  async logout(): Promise<void> {
    // Chamar endpoint de logout do backend
    try {
      await api.post('/auth/logout/')
    } catch (error) {
      console.error('Erro ao fazer logout:', error)
    }
    
    // Remover tokens do localStorage
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user')
  },

  async refreshToken(): Promise<string> {
    const refreshToken = localStorage.getItem('refresh_token')
    if (!refreshToken) {
      throw new Error('No refresh token available')
    }
    
    const response = await api.post<{ access: string }>('/auth/token/refresh/', {
      refresh: refreshToken,
    })
    
    // Atualizar access token
    localStorage.setItem('access_token', response.data.access)
    
    return response.data.access
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('user')
    if (userStr) {
      return JSON.parse(userStr)
    }
    return null
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('access_token')
  },
}
